const divCardTimeline = {
  inspected_by: 'Inspecionado por'
};

export default divCardTimeline;
